import Page from '../../../components/PageWrapper';
import useUserAccount from '../../../hooks/userAccountHook';
import useModal from '../../../hooks/modalHook';
import SuperAdminDashboard from '../../../components/dashboard/superAdmin';
import BrokerDashboard from './broker';
import FinancePartnerDashboard from './financePartnerDashboard';
import ActionBanner from '../../../components/ui/ActionBanner';
import InsurerManagementDashboard from '../../admin/dashboard/insurerDashboard/InsurerManagementDashboard';
import AgentDashboardView from '../../../views/shared/dashboard/AgentsDashboard';
import FuelPartnerDashboard from './FuelProviderDashboard';
import { useMemo } from 'react';


function Dashboard() {
  const { user } = useUserAccount();
  const { ModalComponent } = useModal();

  const getDashboardView = useMemo(() => {
    switch (true) {
      case user.isAgency():
        return <AgentDashboardView />;

      case user.isInsurer():
      case user.isRideSharing():
        return <InsurerManagementDashboard />;

      case user?.isFinancePartner():
        return <FinancePartnerDashboard />;

      case user?.isBroker():
        return <BrokerDashboard />;

      case user?.isInternalAdmin():
        return <BrokerDashboard />;
        // return <SuperAdminDashboard />;

      case user?.isFuelProvider():
        return <FuelPartnerDashboard />;

      default:
        return null;
    }
  }, [user]);

  return (
    <Page title="Dashboard">
      {/* <ActionBanner /> */}

      {getDashboardView}
      <ModalComponent />
    </Page>
  );
}

export default Dashboard;

